import { withSvgIcon } from './withSvgIcon';

export const NavBarRollupIcon = withSvgIcon(
  <>
    <path
      d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M12 8.5V15.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8.5 12H15.5" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
